export const isString = node => typeof node === 'string';
export const hasInvert = type => ['primary'].includes(type);